import { z as zod } from 'zod';

import { CommentSchema } from '#types/schemas/comment.schema';

/**
 * Zod schema for a mailing list comment, extending the base CommentSchema
 * with an additional `mailingListId` property.
 *
 * @see CommentSchema
 * @property {number} mailingListId - The unique identifier of the associated mailing list.
 */
export const MailingListCommentSchema = CommentSchema.extend({
  mailingListId: zod.number(),
});
